import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import SEO from '../../components/SEO';
import '../PageStyles.css';
import './Blog.css';

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await api.get('/blog');
        setPosts(response.data);
      } catch (error) {
        console.error('Failed to fetch blog posts:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <>
      <SEO
        title="Blog"
        description="Read our latest articles, news, and insights"
        keywords="blog, articles, news, updates"
      />

      <div className="page-container">
        <div className="container">
          <h1>Blog</h1>
          <p className="page-subtitle">Latest news, articles, and insights</p>

          {posts.length === 0 ? (
            <div className="card" style={{ textAlign: 'center', padding: '60px 20px' }}>
              <p style={{ color: 'var(--secondary-color)', fontSize: '1.1rem' }}>
                No blog posts available yet. Check back soon!
              </p>
            </div>
          ) : (
            <div className="blog-grid">
              {posts.map((post) => (
                <article key={post.id} className="blog-card">
                  {post.featured_image_url && (
                    <Link to={`/blog/${post.slug}`} className="blog-card-image">
                      <img
                        src={post.featured_image_url}
                        alt={post.title}
                        loading="lazy"
                      />
                    </Link>
                  )}

                  <div className="blog-card-content">
                    {post.published_at && (
                      <time className="blog-date" dateTime={post.published_at}>
                        {new Date(post.published_at).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </time>
                    )}

                    <Link to={`/blog/${post.slug}`}>
                      <h2 className="blog-title">{post.title}</h2>
                    </Link>

                    {post.excerpt && (
                      <p className="blog-excerpt">{post.excerpt}</p>
                    )}

                    <Link to={`/blog/${post.slug}`} className="btn btn-primary read-more-btn">
                      Read More →
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Blog;
